import { callApi } from './api';

export type LineUserRequest = {
  line_id: string;
  staff_id?: number;
  guardian_id?: number;
};

export const updateLineUser = async (requestBody: LineUserRequest) => {
  const { status, result } = await callApi<boolean>(`line/users`, 'PUT', undefined, requestBody);
  return { status, result };
};
